'use client'

/* eslint-disable @typescript-eslint/no-floating-promises */
import React, { useEffect, useState } from 'react'
import BusinessModals from '@components/BusinessModal/businessModals'
import { sendEnterpriseEvent } from '@utils/enterpriseSegmentEvent'
import { EVENT_TYPE, TAP_EVENT, VIEW_LEAD_GEN_POPUP } from '@constants/enterpriseSegmentData'
import styles from './leadNudge.module.scss'

const LeadNudge = ({ data }) => {
  const { heading, subtext, ctaText, imageSrc, imageAlt, formSnippet } = data?.data
  const [isModalOpen, setIsModalOpen] = useState(false)

  useEffect(() => {
    if (isModalOpen) {
      sendEnterpriseEvent({ view_name: VIEW_LEAD_GEN_POPUP }, EVENT_TYPE.VIEW)
    }
  }, [isModalOpen])

  return (
    <div className={styles.leadNudgeWrapper}>
      <div className={styles.leadNudgeContainer}>
        <div className={styles.imageContainer}>
          <img src={imageSrc?.data?.attributes?.url} alt={imageAlt} />
        </div>
        <div className={styles.textContainer}>
          <h2 className={styles.heading}>{heading}</h2>
          <h3 className={styles.subtext}>{subtext}</h3>
          <button
            className={styles.ctaButton}
            onClick={() => {
              sendEnterpriseEvent({ action_name: ctaText, view_name: VIEW_LEAD_GEN_POPUP, action_type: TAP_EVENT.TAP_LEAD_GEN_POPUP })
              setIsModalOpen(!isModalOpen)
            }}
            type="button"
          >
            {ctaText}
          </button>
        </div>
      </div>
      <BusinessModals isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} content={formSnippet} />
    </div>
  )
}

export default LeadNudge
